import { render, staticRenderFns } from "./Libero.vue?vue&type=template&id=1c38fab1&scoped=true"
import script from "./Libero.vue?vue&type=script&lang=js"
export * from "./Libero.vue?vue&type=script&lang=js"
import style0 from "./Libero.vue?vue&type=style&index=0&id=1c38fab1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38fab1",
  null
  
)

export default component.exports